import { Component, OnInit, SecurityContext, Input, Output, EventEmitter } from '@angular/core'
import { PatientDemographics, Patient, DataPageOfPayers } from '../../../../api/models'
import { FinancialService, GlobalSettingsService, PatientService } from '../../../../api/services'
import { MessageService } from 'primeng/api'
import { ActivatedRoute } from '@angular/router'
import { Observable, concat } from 'rxjs'
import { toArray } from 'rxjs/operators'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'

import { AsYouType } from 'libphonenumber-js'
import { CareFinitySession } from '../../../services/CareFinitySession'

@Component({
  selector: 'app-patient-info',
  templateUrl: './patient-info.component.html',
  styleUrls: ['./patient-info.component.css'],
})
export class PatientInfoComponent implements OnInit {
  imagesource: any
  ptdemographics: PatientDemographics
  ptDetails: Patient
  address1: string = ''
  address2: string = ''
  @Input() heading = ''
  otherColumnsArray
    isotherColums: boolean = false;
    isotherContactDetails: boolean = false;
    showInsurance = false;
    payers: Observable<DataPageOfPayers>

    isPatientDemographic: boolean = false;

    isUpdateDemographic: boolean = false;
    isAddPayer: boolean = false;

    
    @Input() patientInfo: Patient;
    @Output() patientChange = new EventEmitter<any>();
  get visible() {
      return CareFinitySession.showPatientBanner ?? true;
  }

  constructor(
    private globalsettingService: GlobalSettingsService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private patientService: PatientService,
      private sanitizer: DomSanitizer,

      private financialService: FinancialService
  ) {}

    ngOnInit() {
        this.isAddPayer = CareFinitySession?.user?.roles?.managePatientPayer === true && CareFinitySession?.practiceSettings?.showPatientPayer === true;
        this.isUpdateDemographic = CareFinitySession?.user?.roles?.managePatientDemographic === true && CareFinitySession?.practiceSettings?.showPatientDemographics === true;
        this.loadPatientDemographics();     
         if (CareFinitySession?.practiceSettings?.showPatientPayer)
         this.payers = this.financialService.financialGetAllPayers();
  }
  loadPatientDemographics() {
    concat(
      this.patientService.patientGetPatientImage({
        practiceId: localStorage.getItem('EmrPracticeId'),
        personId: sessionStorage.getItem('ptId'),
      }),
      this.globalsettingService.globalSettingsGet({}),
      this.patientService.patientGetPatientDetails({
        practiceId: localStorage.getItem('EmrPracticeId'),
        personId: sessionStorage.getItem('ptId'),
      }),
    )
      .pipe(toArray())
      .subscribe((result) => {
        let ptimage, ptdemographics, ptdetails
        ;[ptimage, ptdemographics, ptdetails] = result
        this.ptdemographics = ptdemographics
        this.ptDetails = ptdetails

        this.otherColumnsArray = Object.keys(ptdetails.otherColumns).map(
          (key) => ({
            name: key,
            value: ptdetails.otherColumns[key],
          }),
          )




          if (ptimage == null) {
              this.setDefaultImage()

          }
          else {
              let objectURL = 'data:image/png;base64,' + ptimage

              this.isBase64UrlImage(objectURL).then(image => {

                  if (!image) {

                    this.setDefaultImage()
                  }
                  else {

                      this.imagesource = objectURL



                  }

              })


          }
          if (this.ptDetails.address.indexOf('<br/>') > -1 || this.ptDetails.address.indexOf('<br/>') > -1)
          {
          var Address = this.ptDetails.address.split('<')
          this.address1 = Address[0]
          this.address2 = Address[1].replace('br/>', '')
          } else {
          this.address1 = this.ptDetails.address
          this.address2 = ''
          }
          this.ptDetails.homePhone = this.formatPhone(this.ptDetails.homePhone);
          this.ptDetails.officePhone = this.formatPhone(this.ptDetails.officePhone);
          this.ptDetails.mobileNo = this.formatPhone(this.ptDetails.mobileNo);
          sessionStorage.setItem('mrn', this.ptDetails.mrn);
          sessionStorage.setItem('patientGender', this.ptDetails.gender.toLowerCase());
          this.patientInfo = this.ptDetails;
          this.patientChange.emit(this.patientInfo);

      })
  }

  formatPhone(phone: string) {
    debugger
    if (phone.length == 0) {
      return ''
    }
    var phoneNumber = new AsYouType('US').input(phone)

    return phoneNumber
  }
  dotoggle() {
    debugger

    var elem = document.getElementById('pnlptinfo')

    if (elem.className == 'collapse in') {
      elem.className = 'collapse'
    } else {
      elem.className = 'collapse in'
    }
  }

  otherColumsInfoView() {
    if (this.isotherColums) {
      this.isotherColums = false
    } else {
      this.isotherColums = true
    }
    }


    otherContactDetailToggle() {
        if (this.isotherContactDetails) {
            this.isotherContactDetails = false
        } else {
            this.isotherContactDetails = true
        }
    }

    async  isBase64UrlImage(base64String: string): Promise<boolean> {
    let image = new Image()
    image.src = base64String
    return await (new Promise((resolve) => {
        image.onload = function () {
            if (image.height === 0 || image.width === 0) {
                resolve(false);
                return;
            }
            resolve(true)
        }
        image.onerror = () => {
            resolve(false)
        }
    }))
}


 setDefaultImage() {
    if (this.ptDetails.gender.toLowerCase().indexOf('female') > -1) {
        this.imagesource = 'assets/imagesNew/UserAvatar_female_01.png'
    } else if (this.ptDetails.gender.toLowerCase().indexOf('male') > -1) {
        this.imagesource = 'assets/imagesNew/UserAvatar_male_03.png'
        localStorage.setItem('patientGender', 'male')
    } else {
        this.imagesource = 'assets/images/PatientInfo.png'
    }
    }


    editInsurance() {
        this.showInsurance=true
    }
    newPayerAdded(event) {

       console.log("payer added ",event)

        this.showInsurance = false;
        this.loadPatientDemographics();
    }
    



    updatePatientDetails() {

        this.isPatientDemographic = true;
      //  alert("Update patint info");
    }

    closeDialog() {
        this.isPatientDemographic = false; // closes <p-dialog>
    }
}
